/*
 * @Author: Lina
 * @Date: 2020-08-25 18:02:09
 * @LastEditors: Lina
 * @LastEditTime: 2020-08-25 18:02:31
 */
const businessTypeListAll = {
  1: 'netCar',
  2: 'foodOrdering',
  3: 'ticket',
  4: 'video',
  5: 'vipLounge',
  6: 'hotel',
  8: 'phoneRecharge',
  10: 'youzan',
  11: 'rentCar',
  18: 'redHat',
  19: 'shareBus',
}
export { businessTypeListAll }